import * as React from 'react'

import { Config } from '@chegg-wt/core/config'
import OptimizelyProvider from './OptimizelyProvider'

export const withOptimizelyComponent = <P extends object>(
  Component: React.ComponentType<P>
) => {
  return (props) => {
    return (
      <OptimizelyProvider
        cookieDomain={Config.cookieDomain}
        siteName={Config.tokenSiteCode}
      >
        <Component {...props} />
      </OptimizelyProvider>
    )
  }
}
